export function validateNameRegex(name: string) {
    const NAME_REGEX = /^[a-zäöåA-ZÄÖÅ0-9\-_ ]+$/;

    if (name.length > 0 && !NAME_REGEX.test(name)) {
        return false;
    }
    return true;
}
